import type { GeocodedLocation } from '@/queries';

import type { FinancialOverviewLocation } from '../../types';

type LocationPrecision = 'country' | 'exact' | 'locality' | 'region';

export interface ResolvedFinancialOverviewMapLocation {
    latitude: number;
    longitude: number;
    precision: LocationPrecision;
    source: 'geocoded' | 'provided';
}

const parseCoordinate = (value: unknown, minimum: number, maximum: number) => {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }

    const coordinate = Number(value);

    return Number.isFinite(coordinate) && coordinate >= minimum && coordinate <= maximum ? coordinate : undefined;
};

export const resolveFinancialOverviewMapLocation = (
    location?: FinancialOverviewLocation,
    geocodedLocation?: GeocodedLocation,
): ResolvedFinancialOverviewMapLocation | undefined => {
    const latitude = parseCoordinate(location?.latitude, -90, 90);
    const longitude = parseCoordinate(location?.longitude, -180, 180);

    if (latitude !== undefined && longitude !== undefined) {
        return { latitude, longitude, precision: 'exact', source: 'provided' };
    }

    if (!geocodedLocation) {
        return undefined;
    }

    return {
        latitude: geocodedLocation.latitude,
        longitude: geocodedLocation.longitude,
        precision: geocodedLocation.precision,
        source: 'geocoded',
    };
};

export const getFinancialOverviewLocationLabel = (location?: FinancialOverviewLocation) =>
    [location?.address, location?.city, location?.region, location?.country]
        .map((value) => value?.trim())
        .filter((value): value is string => Boolean(value))
        .join(', ');

export const getFinancialOverviewMapZoom = (location: ResolvedFinancialOverviewMapLocation) => {
    if (location.precision === 'country') {
        return 3;
    }
    if (location.precision === 'region') {
        return 6;
    }

    return 10;
};
